import { useTheme, Box, Typography, Container } from '@mui/material';


const PageFooter = () => {
    const theme = useTheme();
    const neutralDark = theme.palette.neutral.darkest;
    const backgroundDefault = theme.palette.background.default;

    return (
        <Box component="footer" sx={{ bgcolor: backgroundDefault, py: 3 }}>
            <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
                <Typography variant="h5" color={neutralDark}>
                    &copy; {new Date().getFullYear()} DigitAir. All rights reserved.
                </Typography>                
            </Container>
        </Box>
    );
}

export default PageFooter;